export const detailFundsDictionary = {
    "Valor de la cuota parte": {
        es: "Valor de la cuota parte",
        en: "Share Value",
    },
    Actualización: {
        es: "Actualización",
        en: "Update",
    },
    "Fecha de inicio": {
        es: "Fecha de inicio",
        en: "Start Date",
    },
    "Plazo de rescate": {
        es: "Plazo de rescate",
        en: "Redemption Period",
    },
    "Tipo de fondo": {
        es: "Tipo de fondo",
        en: "Fund Type",
    },
    Moneda: {
        es: "Moneda",
        en: "Currency",
    },
    "Patrimonio total": {
        es: "Patrimonio total",
        en: "Total Assets",
    },
    "Inversión mínima": {
        es: "Inversión mínima",
        en: "Minimum Investment",
    },
    "Hora límite": {
        es: "Hora límite",
        en: "Cut-off Time",
    },
    Calificación: {
        es: "Calificación",
        en: "Rating",
    },
    "Código Bloomberg": {
        es: "Código Bloomberg",
        en: "Bloomberg Code",
    },
    "Honorarios S.R.": {
        es: "Honorarios S.R.",
        en: "SR Fees",
    },
    "Honorarios S.G.": {
        es: "Honorarios S.G.",
        en: "SG Fees",
    },
    "Honorarios S.D.": {
        es: "Honorarios S.D.",
        en: "SD Fees",
    },
    "Honorarios total": {
        es: "Honorarios total",
        en: "Total Fees",
    },
    "Instrumentos": {
        es: "Instrumentos",
        en: "Instruments",
    },
    "Gráfico de": {
        es: "Gráfico de",
        en: "Chart of",
    },
    "Valores porcentuales al": {
        es: "Valores porcentuales al",
        en: "Percentage values at",
    },
    "Valores porcentuales sobre el total de la cartera al": {
        es: "Valores porcentuales sobre el total de la cartera al",
        en: "Percentage values on the total portfolio at",
    },
    VCP: {
        es: "VCP",
        en: "SP",
    },
    "Variación diaria": {
        es: "Variación diaria",
        en: "Daily Variation",
    },
    "Sociedad depositaria": {
        es: "Sociedad depositaria",
        en: "Custodian",
    },
    "7d": {
        es: "7d",
        en: "7d",
    },
    "30d": {
        es: "30d",
        en: "30d",
    },
    "6m": {
        es: "6m",
        en: "6m",
    },
    "1a": {
        es: "1a",
        en: "1y",
    },
    Composición: {
        es: "Composición",
        en: "Composition",
    },
    "CLASE A": {
        es: "CLASE A",
        en: "CLASS A",
    },
    "CLASE B": {
        es: "CLASE B",
        en: "CLASS B",
    },
    "VALOR CUOTA PARTE": {
        es: "VALOR CUOTA PARTE",
        en: "SHARE VALUE",
    },
    "Descargá la documentación completa": {
        es: "Descargá la documentación completa",
        en: "Download the complete documentation",
    },
    "Var Diaria": {
        es: "Var Diaria",
        en: "Daily Var",
    },
    "Horario límite": {
        es: "Horario límite",
        en: "Cut-off Time",
    },
};
